import CardPay from './CardPay'

export default CardPay
